import { createRouter, createWebHistory } from 'vue-router'
import { getToken, isTokenExpired } from '@/utils/auth'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false, layout: 'blank' }
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/user',
    name: 'User',
    meta: { requiresAuth: true },
    children: [
      {
        path: 'list',
        name: 'UserList',
        component: () => import('../views/user/UserList.vue'),
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/shop',
    name: 'Shop',
    meta: { requiresAuth: true },
    children:[
      {
        path: 'list',
        name: 'ShopList',
        component: () => import('../views/shop/ShopList.vue'),
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path:'/payment',
    name:'Payment',
    meta:{requiresAuth:true},
    children:[
      {
        path:'list',
        name:'PaymentList',
        component:()=>import('../views/payment/PaymentList.vue'),
        meta:{requiresAuth:true}
      },
      {
        path:'setting',
        name:'PaymentSetting',
        component:()=>import('../views/payment/PaymentSetting.vue'),
        meta:{requiresAuth:true}
      }
    ]
  },
  {
    path:'/task',
    name:'Task',
    meta:{requiresAuth:true},
    children:[
      {
        path:'list',
        name:'TaskList',
        component:()=>import('../views/task/TaskList.vue'),
        meta:{requiresAuth:true}
      }
    ]
  },
  {
    path:'/daily',
    name:'Daily',
    meta:{requiresAuth:true},
    children:[
      {
        path:'list',
        name:'DailyList',
        component:()=>import('../views/daily/DailyList.vue'),
        meta:{requiresAuth:true}
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = getToken()
  const requiresAuth = to.meta.requiresAuth !== false
  
  if (requiresAuth && (!token || isTokenExpired())) {
    next({ path: '/login', query: { redirect: to.fullPath } })
  } else if (to.path === '/login' && token && !isTokenExpired()) {
    next('/')
  } else {
    next()
  }
})

export default router
